import { cn } from 'cn'

const buttonClasses = 'border text-sm font-medium text-neutral-800 rounded-md h-8 px-3 shrink-0'

const coloredClasses = [
  'border-transparent',
  '[&>[data-content]>[data-title]]:!text-white',
  '[&>[data-content]>[data-description]]:!text-white',
  '[&>[data-button]]:!text-white',
  '[&>[data-button]]:!border-white/20',
  '[&>[data-close-button]>svg]:text-white',
]

export const toastOptions = {
  unstyled: true,
  classes: {
    toast: cn(
      '[&>[data-icon]]:hidden',
      '[&>[data-content]>[data-title]]:text-neutral-800',
      '[&>[data-content]>[data-description]]:text-neutral-600',
      '[&>[data-button]]:text-neutral-600',
      '[&>[data-close-button]>svg]:text-neutral-800',
      'font-sans',
      'bg-background',
      'border',
      'rounded-md',
      'p-6',
      'flex',
      'gap-4',
      'items-center',
      'justify-between',
      'w-full',
      'shadow-lg',
    ),
    title: 'font-semibold text-sm',
    description: 'text-sm',
    actionButton: buttonClasses,
    cancelButton: buttonClasses,
    closeButton: cn(
      '!right-2',
      '!top-2',
      '!left-auto',
      '!transform-none',
      '!border-none',
      '!size-4',
      '!bg-transparent',
      '[&>svg]:w-full',
      '[&>svg]:h-full',
    ),
    error: cn(...coloredClasses, 'bg-error-400'),
    success: cn(...coloredClasses, 'bg-success-400'),
    warning: cn(...coloredClasses, 'bg-warning-400'),
    info: cn(...coloredClasses, 'bg-info-400'),
  },
}
